<div class="container">
  <div class="icn-hide" *ngIf="!graphicsInfo"></div>
  <div class="icn-show" *ngIf="!!graphicsInfo">
    <icn-edit-graphics-main
      [graphicsInfo]="graphicsInfo"
    ></icn-edit-graphics-main>
    <icn-edit-graphics-aside
      [graphicsInfo]="graphicsInfo"
      (save)="onSave()"
      (goLive)="onGoLive()"
    ></icn-edit-graphics-aside>
  </div>
</div>
